module.exports = __webpack_public_path__ + "static/media/20ECE8.e9d55a17.jpg";